import React from "react";
import "../css/documentos.css";

import escudo from "../img/logos/escudo.png";

const DocumentList = () => {

    const documentos = [

        {
            titulo: "Plan Anual de Desarrollo",
            subtitulo: "PADEM 2024",
            tipo: "Planificación",
            color: "#0B4EA2",
            pdf: "/pdfs/PADEM_2024.pdf",
        },

        {
            titulo: "Proyecto Educativo",
            subtitulo: "PEI",
            tipo: "Proyecto",
            color: "#1B8F4B",
            pdf: "/pdfs/Proyecto Educativo.pdf",
        },

        {
            titulo: "Reglamento de Evaluación",
            subtitulo: "Actualizado",
            tipo: "Reglamento",
            color: "#E67E22",
            pdf: "/pdfs/REGLAMENTO DE EVALUACIÓN 2023.pdf",
        },

        {
            titulo: "Reglamento Interno",
            subtitulo: "RICE 2026",
            tipo: "Convivencia Escolar",
            color: "#C62828",
            pdf: "/pdfs/RICE ACTUALIZADO 2026 10-06.pdf",
        },

        {
            titulo: "Protocolo Escolar",
            subtitulo: "Uso de Celulares",
            tipo: "Protocolo",
            color: "#7B1FA2",
            pdf: "/pdfs/Protocolo escolar.pdf",
        }

    ];

    return (

        <section id="documentos" className="doc-container">

            <div className="doc-header">

                <h2 className="doc-title">

                    Documentos Institucionales

                </h2>

                <p className="doc-subtitle">

                    Biblioteca digital de documentos oficiales de la Escuela Nueva Zelandia.

                </p>

            </div>

            <div className="doc-grid">

                {

                    documentos.map((doc, index) => (

                        <a

                            key={index}

                            href={doc.pdf}

                            target="_blank"

                            rel="noopener noreferrer"

                            className="doc-card"

                        >

                            {/* Barra superior */}

                            <div

                                className="doc-topbar"

                                style={{ backgroundColor: doc.color }}

                            />

                            {/* Etiqueta PDF */}

                            <div className="doc-pdf">

                                PDF

                            </div>

                            {/* Marca de agua */}

                            <img

                                src={escudo}

                                alt=""

                                className="doc-watermark"

                            />

                            {/* Escudo */}

                            <img

                                src={escudo}

                                alt="Escuela Nueva Zelandia"

                                className="doc-logo"

                            />

                            {/* Nombre Colegio */}

                            <div className="doc-school">

                                ESCUELA NUEVA ZELANDIA

                            </div>

                            {/* Tipo */}

                            <div className="doc-type">

                                {doc.tipo}

                            </div>

                            {/* Línea */}

                            <div className="doc-divider"></div>

                            {/* Nombre */}

                            <div className="doc-name">

                                {doc.titulo}

                            </div>

                            {/* Versión */}

                            <div className="doc-version">

                                {doc.subtitulo}

                            </div>

                            {/* Pie */}

                            <div className="doc-footer">

                                Documento Institucional

                            </div>

                        </a>

                    ))

                }

            </div>

        </section>

    );

};

export default DocumentList;